<template>
  <div>
    <label class="control-label">{{ labelTitle }}</label>
    <AppSelect
      :value="currentValue"
      :options="options"
      :select2-options="select2Options"
      :async-delay="asyncDelay"
      :max-visible-options="maxVisibleOptions"
      :compact="compact"
      @input="selectEventType"
    ></AppSelect>
  </div>
</template>

<script>
import AppSelect from './AppSelect.vue';

export default {
  name: 'AppRedirectSelector',
  extends: AppSelect,
  props: {
    paramKey: {
      type: String,
      default: '',
    },
    labelTitle: {
      type: String,
      required: true,
    },
    additionalParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentValue: {},
    };
  },
  mounted() {
    this.currentValue = this.value;
  },
  methods: {
    selectEventType(value) {
      this.currentValue = value;

      const url = new URL(window.location.href);

      url.searchParams.delete(this.paramKey);

      if (Array.isArray(value)) {
        value.forEach((item) => {
          url.searchParams.append(this.paramKey, item);
        });
      } else {
        url.searchParams.append(this.paramKey, value);
      }

      if (this.additionalParams) {
        Object.entries(this.additionalParams).forEach(([key, value]) => {
          url.searchParams.append(key, value);
        });
      }

      window.location.href = url.toString();
    },
  },
};
</script>
